module.exports = __webpack_public_path__ + "img/electric-engine.c29a6d80.png";